module.exports = __webpack_public_path__ + "static/message-bg_right-3a4598cb22b30e8adbcfcbc29f206fca.png";